import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selected-product-navbar',
  templateUrl: './selected-product-navbar.component.html',
  styleUrls: ['./selected-product-navbar.component.scss'],
})
export class SelectedProductNavbarComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
